import { like_api_like_url } from 'mk/urls/functions';

export function saveLike(xhr, entity, id, isLiked) {
    return xhr.put(like_api_like_url(entity, id), { isLiked });
}
